import { useMerchantById } from '@applyonline/shared'
import { EFinancingProgram } from '@if/core/types'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import PartnerReferralBox from '../../components/PartnerReferralBox'
import { IFINANCE_ID, MEDICARD_ID } from '../../data/merchant-selectors'
import { isMedicardWebSite } from '../../services/query-string'
import { trackGetStartedEvent, useTrackFunnelStepReached } from '../../services/trackingEvents'
import { EPartnerReferral } from '../../types'
import { ETrackedEvents } from '../../types/tracking'

const WelcomePage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { merchantId: merchantIdFromUrl } = useParams()

  let merchantId = merchantIdFromUrl
  if (!merchantId) {
    merchantId = isMedicardWebSite() ? MEDICARD_ID : IFINANCE_ID
  }
  const showPartnerReferrals = !merchantIdFromUrl || merchantIdFromUrl === IFINANCE_ID

  // preloads the merchant
  useMerchantById(merchantId, EFinancingProgram.Personal)

  useTrackFunnelStepReached(ETrackedEvents.Welcome, merchantId)

  const handleGetStarted = () => {
    trackGetStartedEvent(merchantId)
    navigate(`/${merchantId}/new-app/loan-amount`)
  }

  return (
    <>
      <main className="step-0">
        <h4 className="subtitle">{t('welcome.applyInMinutes')}</h4>
        <h1>{t('welcome.prequalifiedRapidly')}</h1>
        <div className="paragraph">
          <p>{t('welcome.answerQuestions')}</p>
        </div>
        <button id="btnBegin" type="button" onClick={() => handleGetStarted()} className="btn btn-blue">
          <span>{t('welcome.getStarted')}</span>
          <i className="fa-regular fa-arrow-right" />
        </button>
      </main>

      {showPartnerReferrals && (
        <div className="partner-referral-container">
          {EPartnerReferral.map((partner) => (
            <PartnerReferralBox key={partner.id} partner={partner} />
          ))}
        </div>
      )}
    </>
  )
}

export default WelcomePage
